var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.feed.from))]),_vm._v(": "+_vm._s(_vm.feed.subject)+" "),_c('br'),_c('iframe',{attrs:{"id":_vm.id,"src":"about:blank"}})])}
var staticRenderFns = []

export { render, staticRenderFns }